'use strict';

var _objectWithoutProperties = require('babel-runtime/helpers/object-without-properties')['default'];

exports.__esModule = true;
exports['default'] = urlMiddleware;

function urlMiddleware(history) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;

    return function (next) {
      return function (action) {

        var result = next(action);

        var url = action.url;

        var rest = _objectWithoutProperties(action, ['url']);

        if (url) {
          if (typeof url === 'function') {
            history.pushState(null, url(getState()));
          } else {
            history.pushState(null, url);
          }
        }

        return result;
      };
    };
  };
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/middleware/urlMiddleware.js
 ** module id = 1054
 ** module chunks = 2
 **/